import { SOC2Scope, SOC2ScopeSchema } from '@/gen/artifacts/v1/model_pb'
import { AssessmentScore, AssessmentScoreSchema } from '@/gen/assessment/v1/assessment_score_pb'
import { ControlStatus, ControlStatusSchema } from '@/gen/controls/v1/control_status_pb'
import {
  AICapability,
  AICapabilitySchema,
  AIPosture,
  AIPostureSchema,
} from '@/gen/inventory/v1/ai_posture_pb'
import { Implication, ImplicationSchema } from '@/gen/inventory/v1/implication_pb'
import { RiskLevel, RiskLevelSchema } from '@/gen/inventory/v1/risk_pb'

import {
  sortAIPosture,
  sortAssessmentScore,
  sortControlStatus,
  sortRiskLevel,
} from '@/const/priority'

export const ASSESSMENT_SCORES = AssessmentScoreSchema.values
  .filter((value) => value.number !== AssessmentScore.UNSPECIFIED)
  .sort((a, b) => sortAssessmentScore(a.number, b.number))

export const ASSESSED_SCORES = ASSESSMENT_SCORES.map(
  ({ number }) => number as AssessmentScore,
).filter((score) => score !== AssessmentScore.NOT_ASSESSED)

// All control statuses sorted by priority
export const CONTROL_STATUS = ControlStatusSchema.values
  .filter((value) => value.number !== ControlStatus.UNSPECIFIED)
  .sort((a, b) => sortControlStatus(a.number, b.number))

// All risk levels sorted by priority
export const RISK_LEVELS = RiskLevelSchema.values
  .filter((value) => value.number !== RiskLevel.UNSPECIFIED)
  .sort((a, b) => sortRiskLevel(a.number, b.number))

export const IMPLICATIONS = ImplicationSchema.values.filter(
  (value) => value.number !== Implication.UNSPECIFIED,
)

export const SOC2_SCOPES = SOC2ScopeSchema.values.filter(
  (value) => value.number !== SOC2Scope.SOC2_SCOPE_UNSPECIFIED,
)

export const AI_POSTURES = AIPostureSchema.values
  .filter((value) => value.number !== AIPosture.AI_POSTURE_UNSPECIFIED)
  .sort((a, b) => sortAIPosture(a.number, b.number))

export const AI_CAPABILITIES = AICapabilitySchema.values.filter(
  (value) => value.number !== AICapability.AI_CAPABILITY_UNSPECIFIED,
)
